import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import {
  AutomationTestFixtureInputCandidate,
  AutomationTestFixtureInputIneligibility,
  AutomationTestFixtureTriggerCandidate,
  AutomationTestFixtureTriggerIneligibility,
} from '@/types/automations.ts';
import { AUTOMATION_TEST_FIXTURE_INPUTS_KEY } from '@/utils/queryKeys.ts';
import { get_automation_test_fixture_inputs_url } from '@/utils/urls.ts';

const useRetrieveAutomationTestFixtureInputs = (versionId: string, enabled = true) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery<{
    automation_version_id: string;
    candidates: AutomationTestFixtureInputCandidate[];
    ineligible_inputs: AutomationTestFixtureInputIneligibility[];
    trigger_candidates: AutomationTestFixtureTriggerCandidate[];
    ineligible_trigger_inputs: AutomationTestFixtureTriggerIneligibility[];
  }, Error>({
    queryKey: AUTOMATION_TEST_FIXTURE_INPUTS_KEY(automationId, versionId),
    queryFn: async () => (
      await apiClient.get(get_automation_test_fixture_inputs_url(automationId, versionId))
    ).data,
    enabled: enabled && !!automationId && !!versionId,
  });
};

export default useRetrieveAutomationTestFixtureInputs;
